module.exports = __webpack_public_path__ + "assets/img/thr.b8b49ecd.png";